import { styled } from '@mui/material/styles'
import MuiAccordion, { accordionClasses } from '@mui/material/Accordion'
import MuiAccordionSummary, {
  accordionSummaryClasses,
} from '@mui/material/AccordionSummary'
import MuiAccordionDetails from '@mui/material/AccordionDetails'

export const Accordion = styled(MuiAccordion)({
  margin: 0,
  '::before': { display: 'none' },

  [`&.${accordionClasses.expanded}`]: { margin: 0 },
})

export const AccordionSummary = styled(MuiAccordionSummary)(() => ({
  minHeight: '48px',
  overflow: 'hidden',
  backgroundColor: 'inherit',
  [`&.${accordionSummaryClasses.expanded}`]: {
    minHeight: '48px',
    overflow: 'hidden',
  },

  [`& .${accordionSummaryClasses.content}`]: {
    margin: '0',
    alignItems: 'center',
    [`&.${accordionSummaryClasses.expanded}`]: {
      margin: '0',
    },
  },
  expanded: {},
}))

export const AccordionDetails = styled(MuiAccordionDetails)(() => ({
  flexDirection: 'column',
}))
